import React, { useEffect, useState } from "react";
import { Button, Box } from "@mui/material";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import NewPatientForm from "./newPatientForm";
import { useMediaQuery } from '@mui/material';


const PatientDetails = ({handleNext, formik, handleAddPatient, handleGetUser, handleUpdateUser, findPatient, setFindPatient, idType, setIdType, idValue, setIdValue, setIsSearching}) => {
  const [disabledButton, setDisabledButton] = useState(true);
  const [patientId, setPatientId] = useState("");
  
  // Initialize isFollowUp directly from localStorage (synchronously) to avoid delay
  const getInitialFollowUpState = () => {
    const followUpFlag = localStorage.getItem("is_follow_up_patient");
    const patientIdInStorage = localStorage.getItem("patient_id");
    
    // Check if follow-up flag exists AND patient_id exists
    if (followUpFlag === "true" && patientIdInStorage) {
      return true;
    }
    return false;
  };
  
  const [isFollowUp, setIsFollowUp] = useState(getInitialFollowUpState);
  const [originalPatientData, setOriginalPatientData] = useState(null);
  const isMobile = useMediaQuery('(max-width:900px)');

  // Also check when formik values load (in case otherId loads from saved data)
  useEffect(() => {
    const followUpFlag = localStorage.getItem("is_follow_up_patient");
    const followUpOtherId = localStorage.getItem("follow_up_other_id");
    const currentOtherId = formik.values.pat_info?.otherId;
    
    if (followUpFlag === "true" && followUpOtherId && currentOtherId && followUpOtherId === currentOtherId) {
      setIsFollowUp(true);
    }
  }, [formik.values.pat_info?.otherId]);

  useEffect(() => {handleProceedDisabled()}, [formik.values.pat_info, formik.errors?.pat_info]);
  const handleProceedDisabled = () => {
    // Diabetes duration fields are optional, so no need to check them
    
    if (
        // formik.values.pat_info.name &&
        formik.values.pat_info.age &&
        formik.values.pat_info.gender &&
        formik.values.pat_info.otherId &&
        formik.values.pat_info.diabetes &&
        !formik.errors?.pat_info
    ) {
        setDisabledButton(false);
    } else {
        setDisabledButton(true);
    }
};


const handleFindPatient = async () => {
    const patient_id = formik.values.pat_info.otherId?.trim();
    if (!patient_id) {
      return;
    }

    setIsSearching(true);
    setPatientId(patient_id)

    const patientData = await handleGetUser(patient_id); 
    
    if (patientData) {
        setOriginalPatientData(patientData);
    
        formik.setValues({
            ...formik.values,
            pat_info: {
                ...patientData, 
                gender: patientData.sex,
                otherId: patientData.other_id, 
            }
        });
    
        setIsFollowUp(true);
        // Store patient_id in localStorage
        if (patientData.id) {
            localStorage.setItem("patient_id", patientData.id);
        }
        // Store follow-up flag and otherId in localStorage
        localStorage.setItem("is_follow_up_patient", "true");
        localStorage.setItem("follow_up_other_id", patientData.other_id || patient_id);
    } else {
        setIsFollowUp(false);
        // Clear follow-up flag if patient not found
        localStorage.removeItem("is_follow_up_patient");
        localStorage.removeItem("follow_up_other_id");
    }
    setIsSearching(false);
};
const hasFormChanged = () => {
    if (!originalPatientData) return false; 

    const { name, age } = formik.values.pat_info;
    const {
        // name: originalName,
        age: originalAge,
    } = originalPatientData;
    const hasChanged =
        // name !== originalName ||
        age !== originalAge

    return hasChanged;
};

return (
    <div>
        {/* <Box
  sx={{
    height: isMobile && '80vh',
    // overflowY: 'auto',
    padding: isMobile && '16px 8px',
  }}
> */}
        <NewPatientForm formik={formik} handleFindPatient={handleFindPatient} isFollowUp={isFollowUp} setIdValue={setIdValue} setIsSearching={setIsSearching} findPatient={findPatient}/>
        {/* </Box> */}
        <div
            style={{
                display: 'flex',
                justifyContent: 'flex-end',
                position: isMobile ? 'fixed' : 'static',
                bottom: isMobile ? 0 : 'auto',
                left: 0,
                width: isMobile ? '100%' : 'auto',
                padding: isMobile ? '12px 16px' : '0',
                background: isMobile ? '#fff' : 'transparent',
                boxShadow: isMobile ? '0 -2px 8px rgba(0,0,0,0.1)' : 'none',
                zIndex: isMobile ? 100 : 'auto',
                marginTop: isMobile ? 0 : '16px',
                gap: '2.5%',
            }}
        >
            <Button
                variant="contained"
                disabled={disabledButton}
                onClick={() => {
                    if (isFollowUp && localStorage.getItem("patient_id")) {
                            let patient_id = localStorage.getItem("patient_id")
                            if (hasFormChanged()) {
                                handleUpdateUser({patient_id});
                            }
                            else{
                                handleNext()
                            }
                            
                    } 
                    else {
                        // handleAddPatient();
                        handleNext()
                    }
                }}
                sx={{
                    borderRadius: "8px",
                    fontWeight: 400,
                    fontSize: "16px",
                    py: 1.5,
                    px: 3,
                    mr: isMobile ? '20px' : 0, // adds right spacing on mobile
                    border: disabledButton
                        ? "1px solid rgba(125, 121, 123, 0.50)"
                        : "1px solid #7D797B80",
                    background: disabledButton
                        ? "var(--Grey, #F4EFF0)"
                        : "linear-gradient(270deg, #051572 7.32%, #0820B4 92.68%)",
                    textTransform: "none"
                }}
                endIcon={<ArrowForwardIcon />}
            >
                {isFollowUp && hasFormChanged() ? "Update Patient" : "Proceed"}
            </Button>
        </div>

    </div>
);
};

export default PatientDetails;